/**
 * @generated SignedSource<<c42027cc90abc4e44c0aff0dbb65c776>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type QuizSubmissionsOverviewContentHeader_ContentUsageFragment$data = {
  readonly passPercentage: number | null;
  readonly product: {
    readonly adminCanLearnMode: boolean;
    readonly productMemberships: {
      readonly totalCount: number;
    };
  } | null;
  readonly " $fragmentType": "QuizSubmissionsOverviewContentHeader_ContentUsageFragment";
};
export type QuizSubmissionsOverviewContentHeader_ContentUsageFragment$key = {
  readonly " $data"?: QuizSubmissionsOverviewContentHeader_ContentUsageFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"QuizSubmissionsOverviewContentHeader_ContentUsageFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "roles"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "QuizSubmissionsOverviewContentHeader_ContentUsageFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "passPercentage",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Product",
      "kind": "LinkedField",
      "name": "product",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": [
            {
              "kind": "Variable",
              "name": "roles",
              "variableName": "roles"
            }
          ],
          "concreteType": "ProductMembershipNodeConnection",
          "kind": "LinkedField",
          "name": "productMemberships",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "totalCount",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "adminCanLearnMode",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "ContentUsage",
  "abstractKey": null
};

(node as any).hash = "004eda0b0bda5c5743388c5cf3731c92";

export default node;
